export default __webpack_public_path__ + "static/media/case_1.f00a2ec2.jpg";